let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3HBL8")).then(() => parcelRequire('fOA0V'));